<template>
  <div class="cart-summary--invoice row">
    <div class="col-12">
      <div class="head">
        <h5>{{ $t('pages.checkout.invoice_title') }}</h5>
        <h6>{{ $t('pages.checkout.invoice_subtitle') }}</h6>
      </div>

    </div>
    <div :class="['col-' + field.colSize]" v-for="(field, index) in fields" :key="index">
      <b-form-group>
        <label :for="field.name" v-html="fieldLabel(field)"></label>
        <template v-if="field.type === 'select'">
          <b-form-select v-model="form[field.name]"
                         :options="field.options"
                         :id="field.name"
                         :name="field.name"
                         :state="errors.has(field.name) && touched[field.name] ? false : null"
                         :placeholder="field.placeholder"
                         @change="onInput(field.name, validate)"
                         @blur="onBlur(field.name)"
                         v-validate="field.validation"/>
        </template>
        <template v-else>
          <b-form-input v-model="form[field.name]"
                        :id="field.name"
                        :name="field.name"
                        :type="field.type"
                        :state="errors.has(field.name) && touched[field.name] ? false : null"
                        :placeholder="field.placeholder"
                        @keyup="onInput(field.name, validate)"
                        @blur="onBlur(field.name)"
                        v-validate="field.validation"/>
        </template>
      </b-form-group>
      <!--      <span v-show="errors.has(field.name)" class="help is-danger">{{ errors.first(field.name) }}</span>-->
    </div>
    <div class="col-12 mt-2">
      <span class="text-help"><span class="text-danger">*</span> {{ $t('pages.checkout.invoice_mandatory') }}</span>
    </div>
  </div>

</template>
<script>
import CartService from "@/services/Cart";

export default {
  name: "InvoiceForm",
  props: {},
  data() {
    return {
      touched: {},
      countries: [],
      form: {
        name: '',
        street: '',
        city: '',
        zip_code: '',
        country: '',
        vat_number: ''
      },
    }
  },
  watch: {
    isValid: {
      handler: function (value) {
        this.$emit('validation', value)
      },
      immediate: true
    }
  },
  computed: {
    isValid() {
      return this.$validator.errors.items.length === 0
    },
    countryOptions() {
      let options = [{value: '', text: this.$t('pages.checkout.invoice_country')}]
      this.countries.forEach(country => {
        options.push({value: country.code, text: country.name})
      })
      return options
    },
    fields() {
      return [
        {
          name: 'name',
          label: this.$t('pages.checkout.invoice_heading'),
          type: 'text',
          validation: 'required',
          placeholder: this.$t('pages.checkout.invoice_heading_placeholder'),
          colSize: '12'
        },
        {
          name: 'street',
          label: this.$t('pages.checkout.invoice_address'),
          type: 'text',
          validation: 'required',
          placeholder: this.$t('pages.checkout.invoice_address'),
          colSize: '8'
        },
        {
          name: 'zip_code',
          label: this.$t('pages.checkout.invoice_zip'),
          type: 'text',
          validation: 'required',
          placeholder: this.$t('pages.checkout.invoice_zip'),
          colSize: '4'
        },
        {
          name: 'city',
          label: this.$t('pages.checkout.invoice_city'),
          type: 'text',
          validation: 'required',
          placeholder: this.$t('pages.checkout.invoice_city'),
          colSize: '6'
        },
        {
          name: 'country',
          label: this.$t('pages.checkout.invoice_country'),
          type: 'select',
          validation: 'required',
          placeholder: this.$t('pages.checkout.invoice_country'),
          colSize: '6',
          options: this.countryOptions
        },
        {
          name: 'vat_number',
          label: this.$t('pages.checkout.invoice_vat'),
          type: 'text',
          validation: 'required',
          placeholder: this.$t('pages.checkout.invoice_vat'),
          colSize: '12'
        },
      ]
    }
  },
  async mounted() {
    let response = await CartService.getCountries()
    this.countries = response.data

    await this.validate()
  },
  methods: {
    async validate() {
      let result = await this.$validator.validateAll()
      if (result) {
        return this.form
      }else{
        return false
      }
    },
    fieldLabel(field) {
      return field.validation === 'required' ? `${field.label} <span>*</span>` : field.label;
    },
    onInput(field, validate) {
      this.touched[field] = true;
      validate()
    },
    onBlur(field) {
      this.touched[field] = true;
    }
  }
}
</script>


<style scoped>

</style>